module.exports = __webpack_public_path__ + "img/1a3362e.png";